import { render } from "./current-indicator-page.vue?vue&type=template&id=2d11d2e7"
import script from "./current-indicator-page.vue?vue&type=script&lang=ts"
export * from "./current-indicator-page.vue?vue&type=script&lang=ts"

import "./current-indicator-page.vue?vue&type=style&index=0&id=2d11d2e7&lang=less"
script.render = render

export default script